<template>

	<section class="full-width no-padding-top" id="referral">

		<div class="container">

			<div class="row">

				<div class="col-12">
					<h2>Refer a friend</h2>
					<p>Share the unique code below and we'll credit your account $20 for each signup - and they'll get 20% off!</p>
				</div>

			</div>

			<div class="row">

				<div class="col-12">

					<div id="referral-wrapper">

						<div id="code">{{code ? code : 'loading'}}</div>
						<p>This is your code - if your friends enter this in the checkout you'll be credited.</p>
						<div>Your credit is <strong>{{credit !== null ? '$' + credit : 'loading'}}</strong></div>

					</div>

				</div>

			</div>

		</div>

	</section>

</template>

<script>
	module.exports = {

		name: 'referral',

		data() {

			return {

				thinking: false,
				code: null,
				credit: null,

			}

		},

		methods: {

			get_data() {

				window.coreHelpers.ajax.call(this, 'GET', 'lc_get_referral_data', false, function(res) {

					console.log('LC: got referral data');
					this.thinking = false;
					this.code = res.data.code;
					this.credit = res.data.credit;

				}, function(res) {

					this.thinking = false;

				});

			},

		},

		mounted() {

			this.get_data();

		}
	}
</script>